<template>
	<div :class="['py-300 py-500-md', data.isDarkTheme ? 'bg-color-content-primary' : 'bg-color-white']">
		<MarketingPageHeader
			:header="header"
			:theme="data.isDarkTheme ? 'dark' : 'light'"
			:is-secondary="false"
		></MarketingPageHeader>
		<div class="container">
			<MarketingSiteCardRow :cards="cards" :theme="data.isDarkTheme ? 'dark' : 'light'" class="mt-200" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { LandingPageHeader } from 'types/layout';
import MarketingPageHeader from '@components/marketing-site/marketing-page-header.vue';
import { MarketingSiteCard } from 'types/marketing-site';
import MarketingSiteCardRow from '@components/marketing-site/marketing-site-card-row.vue';
import { WhyFundriseInvestorAlignmentData } from 'types/sanity/why-fundrise';

interface Props {
	data: WhyFundriseInvestorAlignmentData;
}

const props = defineProps<Props>();

const header = computed((): LandingPageHeader => {
	return {
		title: props.data.panelOverline,
		heading: props.data.panelHeading,
		summary: [props.data.panelSummary]
	};
});

const cards = computed((): Array<MarketingSiteCard> => {
	return props.data.panelTouts.map((card) => ({
		title: card.toutHeading,
		description: card.toutSummary,
		link:
			card.toutCta?.linkText && card.toutCta.url
				? {
						text: card.toutCta.linkText,
						href: card.toutCta.url,
						target: '_blank'
					}
				: undefined
	}));
});
</script>
